<template>
  <div class="exam-detail">
    <div class="container">
      <div class="left">
        <div class="paper">
          <div class="head">
            <h3 class="title">{{ info.examTitle }}</h3>
            <p class="info">
              <span class="num">题量: {{ info.questionList.length }}</span>
              <span class="total">满分: {{ sum(info.questionList) }}</span>
              <span class="time"
                >考试时间: {{ formatDate(info.startTime) }} 至
                {{ formatDate(info.endTime) }}</span
              >
            </p>
            <p class="score" v-show="info.score != null">
              <span>{{ info.score }}</span> 分
            </p>
          </div>
          <div class="questions">
            <div
              class="one-type"
              v-for="(item, idx) in classify(info.questionList)"
              :key="idx"
            >
              <h3 class="type-title">
                {{ questionIndex(idx + 1) }}. {{ checkType(item.type) }} (共{{
                  item.questionList.length
                }}题<span>,{{ sum(item.questionList) }}分</span>)
              </h3>
              <div
                class="one"
                v-for="(q, i) in item.questionList"
                :key="q.questionId"
              >
                <p class="stem" :class="'one-' + q.questionId">
                  <span class="index">{{ i + 1 }}.</span>
                  <span style="color: #909399"
                    >({{ checkType(q.type) }},{{ q.score }}分)</span
                  >
                  {{ q.question }}
                </p>
                <!-- 多选/单选/判断 -->
                <div
                  class="options"
                  v-if="
                    q.type == 'RADIO' ||
                    q.type == 'CHECKBOX' ||
                    q.type == 'BOOLEAN'
                  "
                >
                  <p
                    class="option"
                    v-for="option in q.optionList"
                    :key="option.tag"
                  >
                    <span class="tag">{{ option.tag }}.</span>
                    <span class="text">{{ option.option }}</span>
                  </p>
                </div>
                <div class="answer">
                  <p class="score" v-show="q.userScore != null">
                    <span>{{ q.userScore }}</span> 分
                  </p>
                  <div class="student-answer">
                    <b>我的答案：</b>
                    <div
                      v-if="q.type == 'SUPPLY'"
                      style="display: inline-block; vertical-align: top"
                    >
                      <p v-for="(answer, i) in q.myAnswerList" :key="i">
                        第{{ i + 1 }}空：{{ answer }}
                      </p>
                    </div>
                    <span v-else>{{
                      [...q.myAnswerList].sort().join(",")
                    }}</span>
                  </div>

                  <div class="right-answer" v-show="q.answerList">
                    <b>正确答案：</b>
                    <div
                      v-if="q.type == 'SUPPLY'"
                      style="display: inline-block; vertical-align: top"
                    >
                      <p v-for="(answer, i) in q.answerList" :key="i">
                        第{{ i + 1 }}空：{{ answer }}
                      </p>
                    </div>
                    <span v-else>{{ [...q.answerList].sort().join(",") }}</span>
                  </div>
                </div>
                <div class="answer teacher-comment" v-show="q.type == 'ANSWER'">
                  <b>教师批语：</b>
                  {{ q.questionMemo }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div
          class="one-type"
          v-for="(item, idx) in classify(info.questionList)"
          :key="idx"
        >
          <p class="type-title">
            {{ questionIndex(idx + 1) }}. {{ checkType(item.type) }}
            <span>({{ sum(item.questionList) }}分)</span>
          </p>
          <div class="idxs">
            <p
              class="idx"
              v-for="(q, i) in item.questionList"
              :key="q.questionId"
              @click="goAnchor('.one-' + q.questionId)"
            >
              {{ i + 1 }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { examInfo } from "@/api/exam";
import { checkType, formatDate } from "@/utils/index";
export default {
  data() {
    return {
      checkType,
      formatDate,
      info: {
        questionList: [],
      },
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$loading.show();
      examInfo(this.$route.query.releaseId).then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.info = data;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 格式化题目
    classify(questions) {
      let list = [];
      if (questions) {
        questions.forEach((e) => {
          let type = e.type;
          let obj = {};
          if (list.length == 0) {
            obj.type = type;
            obj.questionList = [e];
            list.push(obj);
          } else {
            let isHas = false;
            list.forEach((item) => {
              if (item.type == type) {
                item.questionList.push(e);
                isHas = true;
              }
            });
            if (!isHas) {
              let newObj = {};
              newObj.type = type;
              newObj.questionList = [e];
              list.push(newObj);
            }
          }
        });
      }
      return list;
    },
    // 题型序号
    questionIndex(index) {
      if (index == 1) {
        return "一";
      } else if (index == 2) {
        return "二";
      } else if (index == 3) {
        return "三";
      } else if (index == 4) {
        return "四";
      } else if (index == 5) {
        return "五";
      }
    },
    // 计算总分
    sum(arr) {
      return Number(
        arr
          .reduce(function (prev, curr) {
            return curr.score + prev;
          }, 0)
          .toFixed(1)
      );
    },
    goAnchor(selector) {
      this.$el.querySelector(selector).scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
    errorHandler() {
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.exam-detail {
  padding-top: 0 !important;
  background-color: rgb(248, 248, 248);
  .container {
    position: relative;
    padding: 20px 0;
    min-height: calc(100vh - 20px);
    text-align: left;
  }
  .left {
    display: inline-block;
    padding: 20px;
    width: calc(100% - 300px);
    height: 100%;
    background-color: #fff;
    vertical-align: top;
    overflow-y: auto;

    .paper {
      padding: 0 20px;
      .head {
        position: relative;
        padding-bottom: 20px;
        border-bottom: solid 1px #ddd;
        .title {
          margin-bottom: 10px;
          font-size: 18px;
        }
        .info {
          color: #909399;
          span {
            margin-right: 20px;
          }
        }
        .score {
          position: absolute;
          top: 20px;
          right: 0;
          color: #f56c6c;
          span {
            font-weight: bold;
            font-size: 20px;
          }
        }
      }
      .questions {
        margin-top: 20px;
        &.type-sort {
          .type-title {
            &:first-child {
              margin-top: 20px;
            }
          }
        }
        .one {
          margin: 20px 0;
          .stem {
            color: #303133;
            .type {
              margin: 0 5px;
              color: #909399;
            }
          }
          .options {
            .option {
              margin-top: 15px;
              color: #303133;
              .tag {
                margin-right: 5px;
              }
            }
          }
          .answer {
            position: relative;
            margin-top: 15px;
            padding: 16px 20px;
            background: #f8f9fa;
            border: solid #f0f3f7 1px;
            border-radius: 3px;
            &.teacher-comment {
              margin-top: 10px;
            }
            .score {
              position: absolute;
              top: 16px;
              right: 20px;
              color: #00b86e;
              span {
                font-weight: bold;
                font-size: 18px;
              }
            }
            .student-answer {
              max-width: 95%;
              margin-bottom: 10px;
            }
            .right-answer {
              max-width: 95%;
              color: #00b86e;
            }
          }
        }
      }
    }
  }
  .right {
    position: fixed;
    top: 20px;
    margin-left: 920px;
    padding: 20px;
    width: 280px;
    height: calc(100% - 40px);
    background-color: #fff;
    vertical-align: top;
    .top-info {
      padding-bottom: 20px;
      border-bottom: solid 1px #ddd;
      .info {
        display: inline-block;
        margin-left: 20px;
        vertical-align: top;
        .name {
          margin-top: 10px;
          font-size: 16px;
          color: #131b26;
        }
        .sno {
          margin-top: 10px;
          color: #8a8b99;
        }
      }
    }
    .type-title {
      margin-bottom: 20px;
      &:not(:first-child) {
        margin-top: 13px;
      }
    }
    .idxs {
      .idx {
        display: inline-block;
        margin-right: 13px;
        margin-bottom: 13px;
        width: 35px;
        height: 35px;
        line-height: 35px;
        background: #ffffff;
        border: solid #94c1ff 1px;
        color: #3a8bff;
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
      }
    }
  }
}
</style>